import { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { updateUserPassword } from '../services/project/userService'; 

// Validation schema for updating the password
const passwordValidationSchema = Yup.object({
  currentPassword: Yup.string().required('Current password is required'),
  newPassword: Yup.string()
    .min(8, 'Password must be at least 8 characters')
    // .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
    // .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
    // .matches(/[0-9]/, 'Password must contain at least one number')
    // .matches(/[\!@#\$%\^&\*\(\)\-_+=\[\]\{\}\|;:,.<>?]/, 'Password must contain at least one special character')
    .required('New password is required'),
  repeatNewPassword: Yup.string()
    .oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
    .required('Repeat new password is required'),
});

const UpdatePasswordModal = ({ user, show, onClose, refetch = () => {} }) => {
  const formik = useFormik({
    initialValues: {
      currentPassword: '',  // Initialize with an empty string
      newPassword: '',      // Initialize with an empty string
      repeatNewPassword: '', // Initialize with an empty string
    },
    validationSchema: passwordValidationSchema,  // Use the password validation schema
    onSubmit: async ({ currentPassword, newPassword }) => {
      try {
        const response = await updateUserPassword(user.id, currentPassword, newPassword);
        if (response.success) {
          toast.success('Password updated successfully!');
          onClose();
          refetch();  // Optionally trigger a refetch to get updated user info
        } else {
          toast.error(response.message || 'Failed to update password');
        }
      } catch (error) {
        console.error('Error updating password:', error);
        toast.error(error.response?.data?.errorMessage || 'Something went wrong');
      }
    },
  });

  return (
    <Modal show={show} onHide={onClose} fullscreen="md-down" centered>
      <Modal.Header closeButton>
        <Modal.Title>Update Password</Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex flex-column" style={{ height: '100%', maxHeight: '80vh', overflowY: 'auto' }}>
        <Form onSubmit={formik.handleSubmit}>
          <Form.Group className="mb-3" controlId="currentPassword">
            <Form.Label>Current Password</Form.Label>
            <Form.Control
              type="password"
              {...formik.getFieldProps('currentPassword')}
              isInvalid={formik.touched.currentPassword && formik.errors.currentPassword}
            />
            <Form.Control.Feedback type="invalid">{formik.errors.currentPassword}</Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3" controlId="newPassword">
            <Form.Label>New Password</Form.Label>
            <Form.Control
              type="password"
              {...formik.getFieldProps('newPassword')}
              isInvalid={formik.touched.newPassword && formik.errors.newPassword}
            />
            <Form.Control.Feedback type="invalid">{formik.errors.newPassword}</Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3" controlId="repeatNewPassword">
            <Form.Label>Repeat New Password</Form.Label>
            <Form.Control
              type="password"
              {...formik.getFieldProps('repeatNewPassword')}
              isInvalid={formik.touched.repeatNewPassword && formik.errors.repeatNewPassword}
            />
            <Form.Control.Feedback type="invalid">{formik.errors.repeatNewPassword}</Form.Control.Feedback>
          </Form.Group>

          <div className="d-flex justify-content-center mt-3">
            <Button type="submit" variant="primary" className="px-5">
              Submit
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default UpdatePasswordModal;
